const ro = {
  _meta: {
    code: "ro",
    name: "Română",
    reportLanguage: "Romanian",
  },

  nav: {
    home:       "Acasă",
    services:   "Servicii",
    pricing:    "Prețuri",
    about:      "Despre",
    contact:    "Contact",
    login:      "Autentificare",
    dashboard:  "Dashboard",
    screening:  "Analiză",
    reports:    "Rapoartele mele",
    account:    "Contul meu",
    admin:      "Admin",
    logout:     "Deconectare",
  },

  auth: {
    title:          "Autentificare",
    subtitle:       "Introdu emailul tău pentru a primi un link de autentificare.",
    emailLabel:     "Adresa de email",
    emailPh:        "tu@exemplu.com",
    btnSend:        "Trimite link de autentificare",
    btnSending:     "Se trimite…",
    successTitle:   "Email trimis!",
    successDesc:    "Verifică inbox-ul și apasă linkul de autentificare. Expiră în 15 minute.",
    errorInvalid:   "Email invalid.",
    errorServer:    "Eroare la trimiterea emailului. Încearcă din nou.",
    orContinueWith: "sau continuă cu",
    google:         "Continuă cu Google",
    noAccount:      "Prima dată aici? Contul se creează automat.",
    linkExpired:    "Link-ul a expirat sau a fost deja folosit. Solicită unul nou.",
  },

  dashboard: {
    title:          "Dashboard",
    welcome:        (name) => `Bun venit, ${name || "utilizator"}!`,
    kpiReports:     "Rapoarte generate",
    kpiRemaining:   "Rapoarte rămase",
    kpiPlan:        "Planul tău",
    kpiExpires:     "Expiră",
    noPlan:         "Fără abonament activ",
    btnNewReport:   "Raport nou",
    btnViewAll:     "Vezi toate rapoartele",
    recentTitle:    "Rapoarte recente",
    noReports:      "Nu ai generat niciun raport încă.",
    noReportsDesc:  "Începe cu o analiză gratuită a manuscrisului tău.",
    btnStart:       "Începe analiza",
  },

  screening: {
    title:          "Analiză manuscris",
    sub:            "Universal Core · Module de gen · Romanian Market Layer",
    versionBadge:   "beta",
    labelTitleReq:  "Titlul manuscrisului *",
    labelAuthor:    "Autor (opțional)",
    labelGenre:     "Genul literar *",
    labelTier:      "Tipul de raport *",
    labelTitlePh:   "ex: Umbrele din Cluj",
    labelAuthorPh:  "Numele autorului",
    labelGenrePh:   "Selectează genul",
    labelTierPh:    "Selectează tipul de raport",
    labelText:      "Text manuscris *",
    labelTextHint:  "Fișiere acceptate: .txt, .docx, .pdf",
    labelDropzone:  "Trage fișierul (.txt, .docx, .pdf) sau click pentru a selecta",
    labelPastePh:   "sau lipește textul direct…",
    labelWordCount: (n) => `${n} cuvinte`,
    labelWordMin:   "Minim 500 cuvinte recomandate",
    genreActivated: (label) => `${label} activat`,
    genreEngines:   (n, names) => `${n} motoare: ${names}`,
    btnSubmit:      "Generează Raport",
    btnSubmitting:  "Analizare în curs…",
    btnNew:         "← Analiză nouă",
    btnExportPDF:   "⬇ Export PDF",
    btnExportDOCX:  "⬇ Export DOCX",
    btnExporting:   "Se generează…",
    btnLibLoading:  "Se încarcă…",
    errRequired:    "Completează toate câmpurile obligatorii.",
    errAuth:        "Trebuie să fii autentificat pentru acest tip de raport.",
    errNoSub:       "Nu ai un abonament activ pentru acest tip de raport.",
    errAPI:         "Eroare la generarea raportului. Încearcă din nou.",
    errPDF:         "Eroare la generarea PDF.",
    errDOCX:        "Eroare la generarea DOCX.",
    loadingMsgs: [
      "Se analizează Universal Core…",
      "Se evaluează modulul de gen…",
      "Se calculează Romanian Market Layer…",
      "Se evaluează potențialul de piață…",
      "Se finalizează verdictul editorial…",
    ],
    freemiumBadge:  "Analiză gratuită",
    freemiumDesc:   "Primești scorul Hook și detecția de gen. Pentru raport complet, alege un pachet.",
    freemiumLimit:  "Ai atins limita de 3 analize gratuite pe zi.",
    reportTitle:    "Raport FEUR",
    reportVersion:  "v1.0",
    reportUnknown:  "Necunoscut",
    savedOk:        "Raport salvat în contul tău.",
    tabUC:          "Universal Core",
    tabMarket:      "Piața Română",
    sectionStrengths:  "✓ Puncte forte",
    sectionWeaknesses: "⚠ Probleme detectate",
    sectionRecs:       "Recomandări editoriale",
    sectionGrammar:    "Gramatică & diacritice",
    sectionGenreFit:   (genre) => `Compatibilitate · ${genre}`,
    sectionSegment:    "Cititor principal",
    sectionChannels:   "Canale recomandate",
    sectionLogline:    "Logline",
  },

  reports: {
    title:          "Rapoartele mele",
    searchPh:       "Caută după titlu sau autor…",
    filterGenre:    "Toate genurile",
    filterVerdict:  "Toate verdictele",
    sortDate:       "Dată (recent)",
    sortScore:      "FEUR Score ↓",
    sortTitle:      "Titlu A–Z",
    count:          (f, t) => `${f} / ${t} rapoarte`,
    empty:          "Nu ai niciun raport salvat.",
    emptyFiltered:  "Niciun raport nu corespunde filtrelor.",
    btnDownloadPDF: "⬇ PDF",
    btnDownloadDOCX:"⬇ DOCX",
    btnDelete:      "Șterge",
    confirmDelete:  "Ștergi acest raport?",
    labelConf:      "Încredere",
  },

  pricing: {
    title:          "Prețuri",
    subtitle:       "Alege pachetul potrivit pentru tine",
    perReport:      "per raport",
    monthly:        "lunar",
    yearly:         "anual",
    saveYearly:     "Economisești 20%",
    btnBuy:         "Cumpără acum",
    btnSubscribe:   "Abonează-te",
    btnCurrent:     "Planul tău actual",
    freemiumTitle:  "Gratuit",
    freemiumDesc:   "3 analize gratuite pe zi · Scor Hook + detecție gen",
    popular:        "Cel mai popular",
    tabPerReport:   "Per raport",
    tabMonthly:     "Lunar",
    tabYearly:      "Anual",
  },

  account: {
    title:          "Contul meu",
    labelName:      "Nume",
    labelEmail:     "Email",
    labelLang:      "Limbă",
    labelPlan:      "Plan activ",
    labelExpires:   "Expiră la",
    labelReports:   "Rapoarte folosite",
    btnSave:        "Salvează",
    btnSaved:       "Salvat!",
    historyTitle:   "Istoric plăți",
    noPayments:     "Nu ai nicio plată înregistrată.",
  },

  admin: {
    title:          "Admin Dashboard",
    statUsers:      "Utilizatori totali",
    statReports:    "Rapoarte generate",
    statRevenue:    "Venituri totale",
    statActiveSubs: "Abonamente active",
    statToday:      "Rapoarte azi",
    statMonth:      "Venituri luna aceasta",
    navStats:       "Statistici",
    navUsers:       "Utilizatori",
    navReports:     "Rapoarte",
    navRevenue:     "Venituri",
    searchUsers:    "Caută utilizator…",
    makeAdmin:      "Fă admin",
    removeAdmin:    "Revocă admin",
  },

  common: {
    loading:        "Se încarcă…",
    error:          "A apărut o eroare.",
    retry:          "Încearcă din nou",
    save:           "Salvează",
    cancel:         "Anulează",
    delete:         "Șterge",
    close:          "Închide",
    back:           "Înapoi",
    next:           "Înainte",
    yes:            "Da",
    no:             "Nu",
    unknown:        "Necunoscut",
    currency:       "RON",
    footerNote:     "FEUR-1 Architecture Specification v1.0 · Narratiq · Powered by EditorialAI România",
  },

  verdicts: {
    publish_now:    "Publish Now",
    minor_revision: "Minor Revision",
    major_revision: "Major Revision",
    structural_edit:"Structural Edit",
    rewrite:        "Rewrite",
    reject:         "Reject",
  },

  rmlVerdicts: [
    { min: 80, label: "Foarte potrivit pentru piața românească"                       },
    { min: 65, label: "Potrivit pentru piața românească, cu poziționare atentă"       },
    { min: 50, label: "Potrivit mai ales pentru indie / self-publishing asistat"       },
    { min: 35, label: "Potențial românesc moderat, nișă locală"                       },
    { min: 0,  label: "Potențial românesc redus în forma actuală"                     },
  ],
};

export default ro;